module.exports = __webpack_public_path__ + "img/entrepreneur.d365465d.png";